import { QuestionReviewWorkflowStepCode } from '@exam-management/task-management';
import { ReadonlyField } from '@shared/components';

import { QuestionReviewContentPreviewer } from '../../components';
import { mappedQuestionReviewStatus } from '../../constants';
import {
  useQuestionReviewTaskQuestionDetails,
  useQuestionReviewTaskQuestionDetailsFormContext,
} from '../../providers';

function getContentForDescriptionFromStatus(
  workflowRoles: { isOwner: boolean; isAssignee: boolean },
  status: QuestionReviewWorkflowStepCode,
  value?: string,
) {
  const { isOwner } = workflowRoles;
  switch (status) {
    case QuestionReviewWorkflowStepCode.QuestionReviewTodo:
    case QuestionReviewWorkflowStepCode.QuestionReviewInReview:
      return isOwner ? (value ?? ' ') : (value ?? '-');
    default:
      return value ?? '-';
  }
}

export default function QuestionReviewResultDescriptionView() {
  const { getValues } = useQuestionReviewTaskQuestionDetailsFormContext();
  const { question, mainTaskDetails, workflowRoles } = useQuestionReviewTaskQuestionDetails();
  const description = getContentForDescriptionFromStatus(
    workflowRoles,
    mappedQuestionReviewStatus[
      mainTaskDetails.currentWorkflowStep.code as keyof typeof mappedQuestionReviewStatus
    ],
    getValues('description'),
  );

  return (
    <ReadonlyField
      label='เนื้อหาที่ต้องการแก้ไข'
      content={
        <QuestionReviewContentPreviewer
          content={description}
          questionId={question.id}
          taskId={mainTaskDetails.id}
        />
      }
    />
  );
}
